import { FormGroup, Theme, makeStyles } from "@material-ui/core";

import { useMemo, useState, useRef } from "react";
import _ from "lodash";
import * as React from "react";
import clsx from "clsx";

import {
  RequestableSaasDestination,
  SaaSDestination,
  WarehouseDestination,
} from "../../../destinations/destinations";
import {
  LoadedDestinationInfo,
  LoadedEventDefinition,
} from "../../../types/global";
import useArrayOfDestinations from "../../../hooks/useArrayOfDestinations";

import { isDestinationEnabledForEvent } from "../../utils";

import MenuButton from "../../../components/MenuButton";
import DestinationsMenu from "./DestinationsMenu";

import { BulkEditTagsMenu } from "./BulkEditTagsMenu";
import { RemoveEventsMenu } from "./RemoveEventsMenu";

const useStyles = makeStyles((theme: Theme) => ({
  buttonGroup: {
    flexDirection: "row",
    gap: theme.spacing(1),
  },
}));

const MENU_ID = "destination-bulk-action-dropdown";

type BulkEditActionsProps = {
  selectedEvents: string[];
  allEvents: LoadedEventDefinition[];
  events: LoadedEventDefinition[];
  onClearSelection: () => void;
  toggleEventForwarding: (destinationId: string, checked: boolean) => void;
  configurableDestinations: Record<
    string,
    | SaaSDestination
    | RequestableSaasDestination
    | WarehouseDestination
    | undefined
  >;
};

function BulkEditActions({
  selectedEvents,
  allEvents,
  events,
  onClearSelection,
  toggleEventForwarding,
  configurableDestinations,
}: BulkEditActionsProps) {
  const classes = useStyles();
  const destinations = useArrayOfDestinations();

  const anchorRef = useRef();
  const [showBulkEditDestinations, setShowBulkEditDestinations] = useState(
    false
  );

  // This function returns a list of all destinations that
  // are toggled ON for all selected events in the list
  const selectedDestinations = useMemo(() => {
    const eventsById = _.keyBy(events, (e) => e.id);
    const isDestSetOnAllEvents = (d: LoadedDestinationInfo) => {
      return _.every(selectedEvents, (eventId) =>
        isDestinationEnabledForEvent(d, d.type_slug, eventsById[eventId])
      );
    };
    return destinations.filter(isDestSetOnAllEvents).map((d) => d.id);
  }, [selectedEvents, events, destinations]);

  return (
    <FormGroup className={clsx(classes.buttonGroup)}>
      <BulkEditTagsMenu allEvents={allEvents} selectedEvents={selectedEvents} />

      <MenuButton
        ref={anchorRef}
        menuID={MENU_ID}
        onClick={() => setShowBulkEditDestinations(!showBulkEditDestinations)}
        label="Edit Destinations"
      />

      <DestinationsMenu
        anchorEl={anchorRef.current}
        menuId={MENU_ID}
        header={`Edit Destinations for ${selectedEvents.length} Events`}
        selectedDestinations={selectedDestinations}
        onToggle={toggleEventForwarding}
        configurableDestinations={configurableDestinations}
        onClose={() => setShowBulkEditDestinations(false)}
        show={showBulkEditDestinations}
      />

      <RemoveEventsMenu
        allEvents={allEvents}
        selectedEvents={selectedEvents}
        onClearSelection={onClearSelection}
      />
    </FormGroup>
  );
}

export default BulkEditActions;
